import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DeviceResponseType } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import { MovementSensorState, MovementStateEnum } from 'lavva.exalushome/build/js/Services/Devices/IDeviceState';
import { ConditionsTypes } from 'lavva.exalushome/build/js/Services/Scenes/Scenes';
import { SupportedArgumentTypes } from 'lavva.exalushome/build/js/Services/Scenes/ScenesBuilder';
import { InputSelect, SubmitButton } from '../../../../../../../../components';
import { ConditionTypeSelect } from '../../../../components/condition-type-select';
import { InputString } from '../../../../components/input-string';
import { TriggerMethodSelect } from '../../../../components/trigger-method-select';
import { useExalusCreateActionContext } from '../../../../context';
import { useConditionEdit } from '../../../../hooks/use-condition-edit';
import { TriggerMethodType } from '../../../../../../../../types/actions';
import { useActionParameterOptions } from '../../../../utils/use-action-parameter-options';

export const MovementParameters: React.FC = () => {
  const { t } = useTranslation('action');
  const { channels } = useExalusCreateActionContext();
  const { movementOptions } = useActionParameterOptions();
  const [movementOption, setMovementOption] = useState<MovementStateEnum>(MovementStateEnum.Yes);
  const {
    triggerMethod,
    seq,
    timeSec,
    conditionType,
    onlyParametersEdit,
    changeableAtMeetCondition,
    setConditionType,
    setTimeSec,
    updateTriggerMethod,
    saveConditionParams,
    createDeviceArgumentWithComparison,
  } = useConditionEdit({ supportedParam: SupportedArgumentTypes.ArgumentAsDeviceState });

  useEffect(() => {
    const argument = seq?.LeftArgument.Argument?.ArgumentAsDeviceState;

    if (argument && onlyParametersEdit) {
      const state = argument.GetCheckDeviceState<MovementSensorState>();
      setMovementOption(state.Movement);
    }
  }, [seq, onlyParametersEdit]);

  const onChange = (option: MovementStateEnum) => setMovementOption(option);

  const handleSubmit = () => {
    if (channels.length) {
      const deviceArgument = createDeviceArgumentWithComparison();
      deviceArgument.Type = DeviceResponseType.MovementSensorState;
      deviceArgument.DeviceGuid = channels[0].GetDevice().Guid;
      const sensorState = new MovementSensorState();
      sensorState.Channel = channels[0].Number;
      sensorState.Movement = movementOption;
      deviceArgument.SetCheckDeviceState<MovementSensorState>(sensorState);

      saveConditionParams(deviceArgument);
    }
  };

  return (
    <>
      {changeableAtMeetCondition ? (
        <TriggerMethodSelect triggerMethod={triggerMethod} updateTriggerMethod={updateTriggerMethod} />
      ) : null}
      {triggerMethod === TriggerMethodType.WhenChangeOn && changeableAtMeetCondition && (
        <InputString
          value={timeSec}
          setValue={setTimeSec}
          label={t('action.create.conditions.sources.device.requiredTime')}
          inputType="number"
          min={1}
        />
      )}
      <ConditionTypeSelect
        conditionType={conditionType}
        setConditionType={setConditionType}
        allow={[ConditionsTypes.Equal, ConditionsTypes.NotEqueal]}
      />
      <InputSelect
        options={movementOptions}
        value={movementOption}
        onChange={onChange}
        label={t('action.create.conditions.sources.device.movementSensor')}
      />
      <SubmitButton onClick={handleSubmit} />
    </>
  );
};
